import { FC } from 'react'
import { ReactPaginateProps } from 'react-paginate'
import cx from 'classnames'

import { Icons } from '../Icon'

import * as SC from './styled'

export type PaginationProps = ReactPaginateProps & {
  className?: string
  texts?: {
    prev?: string
    next?: string
  }
}

const Pagination: FC<PaginationProps> = ({
  pageCount,
  className,
  onPageChange,
  texts,
  ...others
}) => {
  return (
    <SC.Container
      className={cx('Pagination', className)}
      pageCount={pageCount}
      onPageChange={onPageChange}
      {...others}
      previousLabel={
        <SC.NavPrev>
          <SC.NavIcon icon={Icons.chevronLeft} title={texts?.prev} />
        </SC.NavPrev>
      }
      nextLabel={
        <SC.NavNext>
          <SC.NavIcon icon={Icons.chevronRight} title={texts?.next} />
        </SC.NavNext>
      }
    />
  )
}

export default Pagination
